/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LabelPrintInfo } from '../../models/label-print-info';
import { LabelType } from '../../models/label-type';

export interface GetBobbinPrintInfo$Params {
  producedMaterialId?: number;
  labelType?: LabelType;
  productionOrderId: string;
}

export function getBobbinPrintInfo(http: HttpClient, rootUrl: string, params: GetBobbinPrintInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<LabelPrintInfo>> {
  const rb = new RequestBuilder(rootUrl, getBobbinPrintInfo.PATH, 'get');
  if (params) {
    rb.query('producedMaterialId', params.producedMaterialId, {});
    rb.query('labelType', params.labelType, {});
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LabelPrintInfo>;
    })
  );
}

getBobbinPrintInfo.PATH = '/api/v1/PrintLabel/{productionOrderId}/bobbin/PrintInfo';
